var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('button',{staticClass:"c-celestial-quote-history--button",style:({
    '--scoped-cel-color': _vm.color
  }),on:{"click":_vm.show}},[_vm._v(" "+_vm._s(_vm.possessiveForm)+" Quotes ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }